var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ width: _vm.width + 'px', height: _vm.height + 'px', color: _vm.color })},[_c(_vm.svgComponent,{tag:"component",attrs:{"width":_vm.width,"height":_vm.height,"viewBox":`0 0 ${_vm.width} ${_vm.height}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }